module.exports = __webpack_public_path__ + "./img/zip.3f3697e9a6fdfa4d8bb41addf733e4ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Briefcase/entry/icons/zip.png
// module id = ./src/containers/Briefcase/entry/icons/zip.png
// module chunks = 0